export default function addChangeListener(eventChange) {
    window.LeadsWidgetMarket.addEventListener('change', eventChange);
    window.LeadsWidgetMarket.addEventListener('removeChangeListener', () => {
        window.LeadsWidgetMarket.removeEventListener('change', eventChange)
    }, {once: true});
}